import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const AdvancedSearch = (): unknown => {
    return import(/* webpackPrefetch: true */ './advanced-search.vue');
};

export const advancedSearchRoute: RouteRecordRaw = {
    ...ROUTE_DATA.ADVANCED_SEARCH,
    components: {
        main: AdvancedSearch
    }
};
